import * as React from 'react';

import { type DataGridSelection } from '@rematter/ui-web';
import { atom } from 'jotai';

import { inventoryLotQueryAtom } from '../_graphql/queryInventoryLot';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

export const $routeParams = atomFromRoutePath('/inventory/lots/:lotId');

export const $allocationsLimit = atomFromQueryString.number('allocLimit', 50);
export const $allocationsOffset = atomFromQueryString.number('allocOffset', 0);

export const $lotId = atom((get) => {
  const params = get($routeParams);
  return params.__didMatch ? params.lotId : undefined;
});

export const $addMovementsDialogOpen = atom(false);
export const $editDialogOpen = atom(false);
export const $selectedAllocationIds = atom<DataGridSelection>(
  new Set<React.Key>(),
);

export const $remoteLotDetail = inventoryLotQueryAtom((get) => {
  const lotId = get($lotId);
  const allocationsLimit = get($allocationsLimit);
  const allocationsOffset = get($allocationsOffset);

  if (!lotId) {
    return {
      variables: {
        lotId: '',
        allocationsLimit: 50,
        allocationsOffset: 0,
      },
      skip: true,
    };
  }

  return {
    variables: {
      lotId,
      allocationsLimit,
      allocationsOffset,
    },
    skip: false,
  };
});
